import { Components } from '@mui/material';
import { Theme } from '@mui/system';
import { modalContentHorizontalPaddingSize } from '../../components';

export const buildMuiModalComponent = (): Components<Omit<Theme, 'components'>>['MuiModal'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiDialog-paper > .MuiBackdrop-root': {
        backgroundColor: theme.palette.primary.main,
        opacity: '0.6 !important',
      },
      '& .MuiPaper-root': {
        borderRadius: '10px',
        minWidth: '431px',
        boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.1)',
        padding: `0 ${modalContentHorizontalPaddingSize}px`,
        '.MuiDialogTitle-root': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0',
          height: '51px',
          margin: '40px 0 30px',
          '.MuiButtonBase-root': {
            padding: '0 2px 0 0',
            marginLeft: '80px',
            '> svg': {
              fontSize: '43px',
              color: theme.palette.primary.main,
            },
          },
        },
        '& .MuiDialogContent-root': {
          padding: '0 22px 0 0',
          marginBottom: '20px',
        },
        '& .MuiDialogActions-root': {
          padding: '0 22px 25px 0',
        },
      },
    }),
  },
});
